export default __webpack_public_path__ + "static/media/attachment.e6919f0a.svg";